import Utils from './Utils';
const REGION_KEY = 'loginInfo.region';

export const removeRegion = () => Utils.deleteCookie(REGION_KEY);

export const setRegion = region => {
  const savedRegion = localStorage.getItem(REGION_KEY);
  if (region !== savedRegion) {
    localStorage.setItem('loginInfo.diferentRegion', 'true');
  }
  localStorage.setItem(REGION_KEY, region);
};

export const getRegion = () => localStorage.getItem(REGION_KEY);
